export interface TagReplacement {
  tagName: string;
  replacementHTML: string;
  fileName?: string; // Optional filename for image tags
}

// New interface to match dict.js structure
export interface DictContentStructure {
  CompanyInfo: {
    COMPANY_NAME: string;
    COMPANY_EMAIL: string;
    COMPANY_PHONE: string;
    COMPANY_ADDRESS: string;
    COMPANY_COPYRIGHT: string;
  };
  HeroSection: {
    HERO_MAIN_TITLE: string;
    HERO_SUBTITLE: string;
    HERO_DESCRIPTION: string;
  };
  AboutSection?: {
    ABOUT_MAIN_HEADING: string;
    ABOUT_DESCRIPTION_1: string;
    ABOUT_DESCRIPTION_2: string;
    ABOUT_DESCRIPTION_3: string;
  };
  CapabilitiesSection: {
    CAPABILITIES_MAIN_HEADING: string;
    CAPABILITIES_DESCRIPTION: string;
    services: Array<{
      [key: string]: string;
    }>;
  };
  EquipmentSection: {
    EQUIPMENT_OVERVIEW_DESCRIPTION: string;
    equipmentItems: Array<{
      [key: string]: string;
    }>;
  };
  AdditionalServicesSection: {
    ADDITIONAL_SERVICES_DESCRIPTION: string;
    ADDITIONAL_SERVICES_HEADING: string;
    additionalServices: Array<{
      [key: string]: string;
    }>;
  };
  ContactSection: {
    CONTACT_MAIN_HEADING: string;
    CONTACT_DESCRIPTION: string;
  };
  FooterSection: {
    FOOTER_DESCRIPTION: string;
  };
}

export interface TagBasedGenerationRequest {
  business_data: BusinessData[];
  template_html?: string;  // Optional for optimized approach - reduces payload size by ~80%
  content_preferences?: ContentPreferences;
}

export interface TagBasedGenerationResponse {
  status: string;
  data: TagReplacement[] | DictContentStructure; // Support both old and new formats
  message: string;
}

export interface BusinessData {
  contact_email?: string;
  company_name: string;
  company_desc?: string;
  current_website_url?: string;
  capabilities?: string[];
  other_capabilities?: string;
  equipment?: string;
  logo_url?: LogoUrl[];
  industry?: string;
  services?: string[];
  target_audience?: string;
}

export interface LogoUrl {
  name: string;
  url: string;
}

export interface ContentPreferences {
  tone?: string;
  style?: string;
  industry?: string;
  key_messages?: string[];
}

export interface AIContentGeneration {
  status: 'generating' | 'completed' | 'error';
  tagReplacements: TagReplacement[];
  hasChanges: boolean;
  errorMessage?: string;
}

export interface ContentUpdate {
  tagName: string;
  context: string;
  originalContent: string;
  newContent: string;
  isChanged: boolean;
}

export enum ChatPhase {
  DATA_COLLECTION = 'data-collection',
  AI_GENERATION = 'ai-generation',
  DEPLOYMENT = 'deployment',
  COMPLETED = 'completed'
} 